'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _reactDndTouchBackend = require('react-dnd-touch-backend');

var _reactDndTouchBackend2 = _interopRequireDefault(_reactDndTouchBackend);

var _reactDnd = require('react-dnd');

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _browser = require('../utils/services/browser');

var browserService = _interopRequireWildcard(_browser);

var _CollaborationManager = require('../utils/collaboration/CollaborationManager');

var _CollaborationManager2 = _interopRequireDefault(_CollaborationManager);

var _WorkspaceDragLayer = require('./dnd/WorkspaceDragLayer');

var _WorkspaceDragLayer2 = _interopRequireDefault(_WorkspaceDragLayer);

var _SocketConnectionStatusError = require('../components/error/SocketConnectionStatusError');

var _SocketConnectionStatusError2 = _interopRequireDefault(_SocketConnectionStatusError);

var _PopupPanelMobileContainer = require('../components/popupPanel/PopupPanelMobileContainer');

var _PopupPanelMobileContainer2 = _interopRequireDefault(_PopupPanelMobileContainer);

var _WorkspaceErrorModalManager = require('../components/error/WorkspaceErrorModalManager');

var _WorkspaceErrorModalManager2 = _interopRequireDefault(_WorkspaceErrorModalManager);

var _PageLoaderContainer = require('../components/loaders/PageLoaderContainer');

var _PageLoaderContainer2 = _interopRequireDefault(_PageLoaderContainer);

var _NotificationPollManager = require('../notifications/NotificationPollManager');

var _NotificationPollManager2 = _interopRequireDefault(_NotificationPollManager);

var _Workspace = require('./Workspace');

var _Workspace2 = _interopRequireDefault(_Workspace);

var _MobileWorkspace = require('./mobile/MobileWorkspace');

var _MobileWorkspace2 = _interopRequireDefault(_MobileWorkspace);

var _WorkspaceKeyboardShortcutHandler = require('./decorators/WorkspaceKeyboardShortcutHandler');

var _WorkspaceKeyboardShortcutHandler2 = _interopRequireDefault(_WorkspaceKeyboardShortcutHandler);

var _DragModifierKeysListener = require('../utils/dnd/modifierKeys/DragModifierKeysListener');

var _DragModifierKeysListener2 = _interopRequireDefault(_DragModifierKeysListener);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
// Lib
var getDragDropBackend = function getDragDropBackend() {
    return browserService.isMobile() ? _reactDndTouchBackend2.default : _reactDndHtml5Backend2.default;
};

/* ----
 * WorkspaceContainer
 * This component the middle level of the workspace stack
 * it's responsible for interaction:
 *    - drag & drop
 *    - keyboard shortcuts
 */

// Components
var WorkspaceContainer = function WorkspaceContainer(props) {
    var currentBoardId = props.currentBoardId,
        pageTitle = props.pageTitle,
        socketConnection = props.socketConnection,
        location = props.location,
        showLoader = props.showLoader,
        showLoaderQuote = props.showLoaderQuote,
        isMobileView = props.isMobileView;


    if (showLoader) {
        return _react2.default.createElement(_PageLoaderContainer2.default, {
            quoteFade: true,
            quoteShow: showLoaderQuote,
            logoFade: true,
            logoShow: showLoaderQuote });
    }

    return _react2.default.createElement(
        _CollaborationManager2.default,
        { currentBoardId: currentBoardId },
        _react2.default.createElement(
            _reactDocumentTitle2.default,
            { title: pageTitle },
            _react2.default.createElement(
                'div',
                { className: 'WorkspaceWrapper' },
                isMobileView ? _react2.default.createElement(_MobileWorkspace2.default, props) : _react2.default.createElement(_Workspace2.default, props),
                _react2.default.createElement(_SocketConnectionStatusError2.default, { socketConnection: socketConnection }),
                _react2.default.createElement(_WorkspaceErrorModalManager2.default, { currentBoardId: currentBoardId, location: location }),
                _react2.default.createElement(_WorkspaceDragLayer2.default, { currentBoardId: currentBoardId }),
                _react2.default.createElement(_PopupPanelMobileContainer2.default, props),
                _react2.default.createElement(_NotificationPollManager2.default, null),
                _react2.default.createElement(_DragModifierKeysListener2.default, null),
                _react2.default.createElement(_WorkspaceKeyboardShortcutHandler2.default, props)
            )
        )
    );
};

WorkspaceContainer.propTypes = {
    currentBoardId: _propTypes2.default.string,
    currentBoard: _propTypes2.default.object,
    showLoader: _propTypes2.default.bool,
    showLoaderQuote: _propTypes2.default.bool,
    isMobileView: _propTypes2.default.bool,
    pageTitle: _propTypes2.default.string,
    socketConnection: _propTypes2.default.object,
    location: _propTypes2.default.object
};

exports.default = (0, _reactDnd.DragDropContext)(getDragDropBackend())(WorkspaceContainer);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/WorkspaceContainer.js
// module id = 2151
// module chunks = 0